<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-title>Content</mat-card-title>
    </mat-card-header>
    @if (client$ | async; as client) {
        <mat-card-content>
            <h4>Storage</h4>
            <span>{{ client.storage_use | bytes }} / {{ client.storage_quota | bytes }}</span>
            <mat-progress-bar
                mode="determinate"
                [value]="(client.storage_use / client.storage_quota) * 100"
            ></mat-progress-bar>
        </mat-card-content>
        <mat-card-actions>
            @if (client.is_paid) {
                <button mat-stroked-button (click)="openStorageDialog(client.id)" color="accent">
                    Get More Storage
                </button>
            } @else {
                <button
                    mat-stroked-button
                    routerLink="/pricing"
                    color="primary"
                    matTooltip="In order to get more storage space, you'll need to upgrade your account"
                >
                    Upgrade Account
                </button>
            }
            <button mat-stroked-button [routerLink]="['/a/content']" color="primary">View</button>
        </mat-card-actions>
    }
</mat-card>
